import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './walking.json';

const Walking = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Walking benefits, urban design, and health vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Walking"
            image="/Images/walking.webp"
            seoTitle="Free English Lesson Plans: Walking"
            seoDescription="Walking benefits, urban design, and health vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Walking;


